export class OTPRequestDTO {
  UserIdentifier: string;
  OTP?: string;
  IsEmail: boolean;
  Password: string;
  FirstName: string;
  LastName: string;
  JsonString?: string;
}

export class AuthRequestDTO {
  Username: string;
  OTP: string;
  IsEmail?: boolean;
  JsonString: string;
  Password: string;
  Authmethod?: string;
  FirstName?: string;
  LastName?: string;
  Country?: string;
  State?: string;
  City?: string;
  ZipCode?: string;
  Email?: string;
  MobileNumber?: string;
  IsAppliedWithLinkedin?: boolean;
}



// WEBPACK FOOTER //
// ../UI/src/app/shared/authentication/otp-request-dto.ts